export enum PersonType {
  FirstPersonSingular,
  ThirdPersonSingular
}
